<script setup lang="ts">
import './assets/style.scss'
import { VIcons } from '@/shared/ui'

const zoom = defineModel()
const zoomLimits = {
  max: 20,
  min: 0,
}

/**
 * Увеличиваем значение зума
 */
const zoomUpHandler = () => {
  const value = Number(zoom.value) + 1
  zoom.value = value > zoomLimits.max ? 20 : value
}

/**
 * Уменьшаем значение зума
 */
const zoomDownHandler = () => {
  const value = Number(zoom.value) - 1
  zoom.value = value < zoomLimits.min ? 0 : value
}
</script>

<template>
  <div class="v-map-zoom__wrapper">
    <VTooltip location="left" :open-delay="500" :text="$t('itf.map_zoom_in')">
      <template #activator="{ props }">
        <VBtn
          class="v-map-zoom__btn"
          :disabled="zoom === zoomLimits.max"
          v-bind="props"
          @click="zoomUpHandler"
        >
          <VIcons type="add" />
        </VBtn>
      </template>
    </VTooltip>

    <VTooltip location="left" :open-delay="500" :text="$t('itf.map_zoom_out')">
      <template #activator="{ props }">
        <VBtn
          class="v-map-zoom__btn"
          :disabled="zoom === zoomLimits.min"
          v-bind="props"
          @click="zoomDownHandler"
        >
          <VIcons type="remove" />
        </VBtn>
      </template>
    </VTooltip>
  </div>
</template>
